/* Gambar aliran pada card workflow (page /workflow) — token ILUSTRASI_WF dilukis dengan ikon monokrom.
   Dikongsi oleh card galeri + pemilih gambar dalam popup edit. Tiada warna tetap (tema v3.9). */
import {
    Image, Clapperboard, IdCard, FileText, LayoutTemplate, ArrowRight, Plus, Star, Eye, RefreshCw, ImagePlus,
} from 'lucide-react';
import { ilustrasiWf } from '../utils/galeriWorkflow';

const IKON = {
    g: Image, v: Clapperboard, c: IdCard, t: FileText, m: LayoutTemplate,
    s: Star, e: Eye, r: RefreshCw, k: ImagePlus,
};

export default function GambarAliranWf({ ilustrasi, saiz = 26, className }) {
    const { token } = ilustrasiWf(ilustrasi);
    return (
        <div className={className} aria-hidden="true">
            {[...token].map((ch, i) => {
                if (ch === '>') return <ArrowRight key={i} size={Math.round(saiz * 0.6)} className="wfg-art__panah" />;
                if (ch === '+') return <Plus key={i} size={Math.round(saiz * 0.6)} className="wfg-art__panah" />;
                if (ch === '|') return <span key={i} className="wfg-art__pisah" />;
                const Ikon = IKON[ch];
                return Ikon ? <Ikon key={i} size={saiz} strokeWidth={1.6} /> : null;
            })}
        </div>
    );
}
